import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PWProductDto } from '../../models/pw-product.dto';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PwProductService {

  private readonly path = '/pw/product';

  constructor(private http: HttpClient) { }

    update(productDto: PWProductDto): Promise<Observable<any>> {
      return this.compressBase64ToFile(productDto.image, 'image.jpg').then((file) => {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('pwProductId', productDto.id.toString());
        return this.http.put<any>(`${environment.apiBaseUrl}${this.path}`, formData);
      });
    }

  compressBase64ToFile(base64: string, fileName: string, mimeType = 'image/jpeg', quality = 0.8): Promise<File> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;
  
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject('Canvas context is null');
        ctx.drawImage(img, 0, 0);
  
        canvas.toBlob(
          (blob) => {
            if (blob) {
              const file = new File([blob], fileName, { type: mimeType });
              resolve(file);
            } else {
              reject('Erro ao gerar blob');
            }
          },
          mimeType,
          quality
        );
      };
      img.onerror = (err) => reject(err);
      img.src = base64;
    });
  }
  

}
